import React, { useEffect, useState } from "react"
import { confirmSignIn } from "aws-amplify/auth"
import { LoginInput } from "../login-input"
import { LoginButton } from "../login-button"
import { utilService } from "../../../services/util-service"
import errorIcon from '../../../assets/img/error-icon.svg'

interface UpdatePasswordProps {
    setNextStep: React.Dispatch<any>
}


export const UpdatePassword: React.FC<UpdatePasswordProps> = ({ setNextStep }) => {
    const [newPassword, setNewPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [isCredentailsError, setIsCredentialsError] = useState(false)

    useEffect(() => {
        return () => {
            setNewPassword("")
            setConfirmPassword("")
        }
    }, [])

    const newPasswordValidation = (password: string) => {
        return utilService.isValidPassword(password)
    }

    const confirmPasswordValidation = (confirmPassword: string) => {
        return confirmPassword === newPassword
    }

    useEffect(() => {
        setIsCredentialsError(false)
    }, [newPassword, confirmPassword])

    const onFormSubmit = async (ev: React.FormEvent) => {
        ev.preventDefault()
        if (!newPasswordValidation(newPassword) || !confirmPasswordValidation(confirmPassword)) return

        try {
            const resSignIn = await confirmSignIn({challengeResponse: newPassword})
            setNextStep(resSignIn.nextStep)
        } catch (e) {
            console.error('error', e)
            setIsCredentialsError(true)
        }
    }

    return (<>
        <form onSubmit={onFormSubmit} className="update-password password-login-container">
            <LoginInput
                type="password"
                inputValue={newPassword}
                onSetInput={setNewPassword}
                validationFunc={newPasswordValidation}
                placeholder="New password"
                invalidMsg="Invalid password"
            />
            <LoginInput
                type="password"
                inputValue={confirmPassword}
                onSetInput={setConfirmPassword}
                validationFunc={confirmPasswordValidation}
                placeholder="Confirm new password"
                invalidMsg="password does not match"
            />
            <div className="login-btn-container">
                <LoginButton txt="update passsword" action={() => null} isFullColor={false} />

                {isCredentailsError && (
                    <div className="credentials-error-msg">
                        <img src={errorIcon} alt="error" />
                        <p>Failed updating password</p>
                    </div>
                )}
            </div>
        </form>
    </>
    )
}
